//Created by wangshuyi on 2021/7/20.

'use strict';

import moment from 'moment';
import dolphinCoreConfig from '../config';

export default {
  name: 'dol-iso-datetime',
  functional: true,
  props: ['format'],
  render(h, { props, data, children }) {
    let str = data.model.value ? moment(data.model.value).format(props.format || dolphinCoreConfig.isoDate.datetimeFormat) : '';
    return h('span', str);
  }
}
